import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import Swal from 'sweetalert2';
import { RestaurantProfile } from '../../../models/List.Restaurant';
import { RestaurantService } from '../../../services/Restaurant.service';

@Component({
  selector: 'app-publish-restaurant',
  templateUrl: './publish-restaurant.component.html'
})
export class PublishRestaurantComponent implements OnInit {
  @Input() restaurantId!: any;
  @Input() publishStatus!: any;
  @Input() restaurantProfile!: RestaurantProfile;
  constructor(private restaurantService: RestaurantService,
    public translate: TranslateService) { }

  ngOnInit(): void {
    // Bug 69386
    let restId = String(this.restaurantProfile.id);
    var links = document.querySelectorAll('.checklist-content a');
    for (var i = 0; i < links.length; i++) {
      links[i].addEventListener('click', function(event) {
        localStorage.setItem("restaurantId", restId);
      });
  }
  }

  checkRestaurantStatus() {
    return this.restaurantProfile.publishStatus.dayavailable
      && this.restaurantProfile.publishStatus.ingredientsunits
      && this.restaurantProfile.publishStatus.kitchen
      && this.restaurantProfile.publishStatus.menu
      && this.restaurantProfile.publishStatus.menuitem
      && this.restaurantProfile.publishStatus.menuitemcategory
      && this.restaurantProfile.publishStatus.stuff
      && this.restaurantProfile.publishStatus.supplier
      && this.restaurantProfile.publishStatus.transaction
  }


  publish() {
    this.restaurantService.PublishRestaurant(this.restaurantId).subscribe((data: any) => {
      if (data) {
        Swal.fire({
          title: this.translate.instant('swalMsg.Success'),
          text: this.translate.instant('swalMsg.restaurantPublished'),
          icon: 'success',
          confirmButtonText: this.translate.instant('swalMsg.Ok')
        }).then(() => {
          location.reload();
        });
      }
    }, error => {
      Swal.fire({
        title: this.translate.instant('swalMsg.Failed'),
        text: error.detail,
        icon: 'error',
        confirmButtonText: this.translate.instant('swalMsg.Ok'),
      }).then(() => {
        location.reload();
      });
    });
  }

  navigateToSideBar(restaurantId: any) {
    localStorage.setItem('restaurantId', restaurantId)
  }

}


